import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import SearchCard from "./_search_card";
import { Skeleton } from "@material-ui/lab";

export default function SearchResult({ searchResult ,searchContent, contentReady}) {
  const [searchData, setsearchData] = useState([]);
  const [faqWidget, setFaqWidget] = useState(false);
  const [userguideWidget, setUserGuideWidget] = useState(false);
  const [linksWidget, setLinksWidget] = useState(false);
  const [announcementWidget, setAnnWidget] = useState(false);
  const [tariffWidget, setTariffWidget] = useState(false);
  const labels = useSelector(
    (state) => state?.labels?.data?.getLabels?.E_SEARCH_RESULT
  );

  const widgets = useSelector(
    (state) => state?.parametersWidgets?.WidgetLookUp
  );

  useEffect(() => {
    if (widgets) {
      widgets.map((item) => {
        if (item.widgetCode === "SIDEBAR.SELFHELP") {
          item.children.map((childItem) => {
            if (
              childItem.widgetCode === "SELFHELP.USER_GUIDES" &&
              childItem.widgetDefaultValue === "true"
            ) {
              setUserGuideWidget(true);
            }
            if (
              childItem.widgetCode === "SELFHELP.FREQUENTLY_ASKED_QUESTIONS" &&
              childItem.widgetDefaultValue === "true"
            ) {
              setFaqWidget(true);
            }
            if (
              childItem.widgetCode === "SELFHELP.LINKS" &&
              childItem.widgetDefaultValue === "true"
            ) {
              setLinksWidget(true);
            }
          });
        }

        if (item.widgetCode === "E_SIDEBAR.ALERTS") {
          item.children.map((childItem) => {
            if (
              childItem.widgetCode === "E_ANNOUNCEMENT" &&
              childItem.widgetDefaultValue === "true"
            ) {
              setAnnWidget(true);
            }
          });
        }
      });
    }
  }, [widgets]);

  useEffect(() => {
    if (searchResult && labels) {
      if (faqWidget) {
          setsearchData((searchData) => [
            ...searchData,
            {
              title: labels?.E_SEARCH_FAQ,
              origin: "FAQ",
              data: searchResult?.hits?.hits?.filter(
                (item) => item?._source?.ContentCategoryCode === "E_FAQS"
              ),
            },
          ]);
    }
      if (announcementWidget) {
        setsearchData((searchData) => [
          ...searchData,
          {
            title: labels?.E_SEARCH_ANN,
            origin: "ANNOUNCEMENT",
            data: searchResult?.hits?.hits?.filter(
              (item) => item?._source?.ContentCategoryCode === "ANNOUNCEMENT"
            ),
          },
        ]);
      }
      if (linksWidget) {
        setsearchData((searchData) => [
          ...searchData,
          {
            title: labels?.E_SEARCH_LINKS,
            origin: "LINKS",
            data: searchResult?.hits?.hits?.filter(
              (item) => item?._source?.ContentCategoryCode === "E_LINKS" || item?._source?.ContentCategoryCode === "E_SIDEBAR"
            ),
          },
        ]);
      }
      if (tariffWidget) {
        setsearchData((searchData) => [
          ...searchData,
          {
            title: labels?.E_SEARCH_TARIFF,
            origin: "TARIFF",
            data: searchResult?.hits?.hits?.filter(
              (item) => item?._source?.ContentCategoryCode === "TARIFF"
            ),
          },
        ]);
      }
      if (userguideWidget) {
        setsearchData((searchData) => [
          ...searchData,
          {
            title: labels?.E_SEARCH_GUIDE,
            origin: "USER_GUIDE",
            data: searchResult?.hits?.hits?.filter(
              (item) => item?._source?.ContentCategoryCode === "E_USER_GUIDES"
            ),
          },
        ]);
      }
    }
  }, [
    searchResult,
    faqWidget,
    announcementWidget,
    linksWidget,
    tariffWidget,
    userguideWidget,
    labels
  ]);

  return (
    <Grid container direction="row" spacing={2}>
      {searchData.length > 0 ?
        searchData.map(
          (data, k) =>
            data.data.length > 0 && (
              <Grid item xs={12} sm={12} md={6} lg={4} key={k}>
                <SearchCard data={data} searchContent={searchContent} contentReady={contentReady}/>
              </Grid>
            )
        ):<Skeleton/>}
    </Grid>
  );
}
